import { Amplify } from "aws-amplify";
import App from "components/App";
import { basename } from "config";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import store from "store";
import "./assets/css/antd-styles.css";
import "./assets/css/masterstyle.css";
import "./assets/css/semantic-ui-styles.css";
import awsconfig from "./aws-exports";
import "./index.css";

Amplify.configure(awsconfig);

window.addEventListener("error", (e) => {
    if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
        e.stopImmediatePropagation();
    }
});

const renderApp = () => (
    <Provider store={store}>
        <BrowserRouter basename={basename}>
            <App />
        </BrowserRouter>
    </Provider>
);

const container = document.getElementById("app");
const root = createRoot(container);
root.render(renderApp());
